export const TOURS = [
  {
    id: "dashboard-tour",
    title: "Dashboard Overview",
    route: "/",
    description: "KPIs, trend charts and quick actions",
    steps: [
      { target: "company-switcher-trigger", title: "Company switcher", body: "Switch between Krishna Group companies here. Each company is a fully separate, isolated workspace." },
      { target: "stat-sales", title: "Live KPI cards", body: "Sales, receivables, collections, stock value, GST and more — all live. Click any card to drill into that module." },
      { target: "sales-trend-chart", title: "Sales vs collections", body: "Month-wise trend for the current financial year. Spot collection gaps at a glance." },
      { target: "recent-invoices-list", title: "Recent invoices", body: "Your latest invoices with live payment status. Click any row to open full details." },
      { target: "quick-action-btn", title: "Quick actions", body: "Create an invoice, record a payment or add a party from anywhere in the app." },
    ],
  },
  {
    id: "invoicing-tour",
    title: "Sales Invoicing",
    route: "/invoices",
    description: "Create and manage GST invoices",
    steps: [
      { target: "new-invoice-btn", title: "New invoice", body: "Start a GST invoice. The engine auto-computes CGST/SGST or IGST based on the place of supply." },
      { target: "invoices-search", title: "Search", body: "Find invoices instantly by number or party name." },
      { target: "invoices-status-filter", title: "Status filter", body: "Narrow down to draft, posted, paid, overdue or cancelled invoices." },
      { target: "invoices-table", title: "Invoice register", body: "Every invoice with totals, balance and live payment status. Click a row for details, printing and payment recording." },
    ],
  },
  {
    id: "payments-tour",
    title: "Payments & Ledger",
    route: "/payments",
    description: "Collections, allocation and party ledgers",
    steps: [
      { target: "new-payment-btn", title: "Record a payment", body: "Capture money received and allocate it across invoices. Overpayments automatically become customer advances." },
      { target: "tab-receivables", title: "Receivables", body: "Who owes you what — outstanding balance per customer, with overdue flags." },
      { target: "tab-unallocated", title: "Unallocated", body: "Advances and unmatched receipts waiting to be applied to invoices." },
      { target: "tab-ledger", title: "Party ledger", body: "Full debit/credit statement with running balance for any party." },
    ],
  },
  {
    id: "purchases-tour",
    title: "Purchases & Payables",
    route: "/purchases",
    description: "POs, bills, supplier payments",
    steps: [
      { target: "tab-purchase-orders", title: "Purchase orders", body: "Raise POs, send for approval, then convert approved POs into bills in one click." },
      { target: "tab-purchase-bills", title: "Purchase bills", body: "Posting a bill increments stock and creates a supplier payable automatically." },
      { target: "tab-payables", title: "Payables", body: "Outstanding amounts you owe to suppliers." },
      { target: "tab-payouts", title: "Payments out", body: "Pay suppliers with multi-bill allocation and oldest-first auto-allocation. Overpayment becomes prepaid credit." },
    ],
  },
  {
    id: "inventory-tour",
    title: "Items & Inventory",
    route: "/items",
    description: "Stock levels, GST rates, warehouses",
    steps: [
      { target: "new-item-btn", title: "New item", body: "Create materials, products, services or labour with HSN codes and GST rates." },
      { target: "items-table", title: "Stock register", body: "Live stock with low-stock badges. Stock moves automatically when invoices and bills are posted." },
      { target: "warehouses-tab", title: "Warehouses", body: "Manage multiple godowns and track stock per location." },
    ],
  },
  {
    id: "reports-tour",
    title: "Reports Center",
    route: "/reports",
    description: "GST, P&L, stock and receivables ageing",
    steps: [
      { target: "report-tab-gst", title: "GST summary", body: "Output tax, input credit and net liability with HSN-wise breakup — filing-ready." },
      { target: "report-from", title: "Date range", body: "Every report supports custom date ranges." },
      { target: "report-export", title: "One-click export", body: "Download any report as CSV to share with your CA." },
    ],
  },
];
